import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteCart,
  decrementQuantity,
  incrementQuantity,
} from "../redux/carts/actions";
import {
  decreaseProductQuantity,
  increaseProductQuantity,
  returnQtyAfterCartDlt,
} from "../redux/products/actions";

const CardItem = ({ cart }) => {
  const dispatch = useDispatch();

  const products = useSelector((state) => state.products);
  const findProduct = products.filter((product) => product.id === cart.id);

  return (
    <div className="cartCard">
      <div className="flex items-center col-span-6 space-x-6">
        {/* <!-- cart image --> */}
        <img className="lws-cartImage" src={cart.img_url} alt="product" />
        {/* <!-- cart item info --> */}
        <div className="space-y-2">
          <h4 className="lws-cartName">{cart.name}</h4>
          <p className="lws-cartCategory">{cart.category}</p>
          <p>
            BDT <span className="lws-cartPrice">{cart.price}</span>
          </p>
        </div>
      </div>
      <div className="flex items-center justify-center col-span-4 mt-4 space-x-8 md:mt-0">
        {/* <!-- amount buttons --> */}
        <div className="flex items-center space-x-4">
          <button
            className="lws-incrementQuantity"
            disabled={findProduct[0].quantity === 0 && true}
            onClick={() => {
              dispatch(incrementQuantity(cart.id));
              dispatch(decreaseProductQuantity(cart.id));
            }}
          >
            <i className="text-lg fa-solid fa-plus"></i>
          </button>
          <span className="lws-cartQuantity">{cart.quantity}</span>
          <button
            className="lws-decrementQuantity"
            disabled={cart.quantity === 1 ? true : false}
            onClick={() => {
              dispatch(decrementQuantity(cart.id));
              dispatch(increaseProductQuantity(cart.id));
            }}
          >
            <i className="text-lg fa-solid fa-minus"></i>
          </button>
        </div>
        {/* <!-- price --> */}
        <p className="text-lg font-bold">
          BDT
          <span className="lws-calculatedPrice">
            {cart.price * cart.quantity}
          </span>
        </p>
      </div>
      {/* <!-- delete button --> */}
      <div className="flex items-center justify-center col-span-2 mt-4 md:justify-end md:mt-0">
        <button
          className="lws-removeFromCart"
          onClick={() => {
            dispatch(deleteCart(cart.id));
            dispatch(returnQtyAfterCartDlt(cart.id, cart.quantity));
          }}
        >
          <i className="text-lg text-red-400 fa-solid fa-trash"></i>
        </button>
      </div>
    </div>
  );
};

export default CardItem;
